export default "__VITE_ASSET__CUer6ePL__"